import { WarehouseLayoutSchema } from "@redotech/redo-fulfillment-wms-common/schema/warehouse";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getWarehouseLayout = {
  name: "getWarehouseLayout" as const,
  input: z.object({ layoutId: zExt.objectId() }),
  output: z.union([z.object({ layout: WarehouseLayoutSchema })]),
};
